import React from 'react';
import { Container, Button, Count, Label, CounterContainer } from './styles';

const CounterInput = ({
  label = '',
  onCounterChange = () => {},
  counterValue = 0,
  disabledDecrease = false,
  disabledIncrease = false,
  min,
  max,
  dataPubli = ''
}) => {
  const increaseCounter = () => {
    const result = Number(counterValue) + 1;
    if (result > max) {
      return;
    }
    onCounterChange(result);
  };

  const decreaseCounter = () => {
    const result = Number(counterValue) - 1;
    if (result < min) {
      return;
    }
    onCounterChange(result);
  };

  return (
    <Container>
      <Label data-publi={`${dataPubli}-label`}>{label}</Label>
      <CounterContainer>
        <Button
          data-publi={`${dataPubli}-decrease`}
          isDisabled={disabledDecrease}
          onClick={!disabledDecrease ? decreaseCounter : null}
        >
          -
        </Button>
        <Count data-publi={`${dataPubli}-counter`}>{counterValue || '-'}</Count>
        <Button
          data-publi={`${dataPubli}-increase`}
          isDisabled={disabledIncrease}
          onClick={!disabledIncrease ? increaseCounter : null}
        >
          +
        </Button>
      </CounterContainer>
    </Container>
  );
};

export default CounterInput;
